// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__9u-f2","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1ze_K"};